export default {
  title: 'Produse',
  buttons: {
    add_product: 'Adaugă produs',
  },
  modals: {
    delete_product: {
      title: 'Ești sigur',
      description:
        'Toate abonamentele curente cu acest produs vor rămâne active, dar nu se mai pot crea abonamente noi cu el. Această acțiune nu poate fi anulată!',
    },
    delete_price: {
      title: 'Ești sigur',
      description:
        'Toate abonamentele curente cu acest preț vor rămâne active, dar nu se mai pot crea abonamente noi cu el. Această acțiune nu poate fi anulată!',
    },
  },
  toasts: {
    failed_to_load_data: 'Eroare la încărcarea datelor',
    failed_to_delete_product: 'Eroare la ștergerea produsului',
    product_got_deleted: 'Produsul a fost șters',
    failed_to_delete_price: 'Eroare la ștergerea prețului',
    price_got_deleted: 'Prețul a fost șters',
  },
};
